import { useState } from "react";
import {
  Alert,
  Button,
  CircularProgress,
  TextField,
  DialogActions,
  DialogContent,
} from "@mui/material";
import ResponsiveDialog from "../UI/ResponsiveDialog";
import { useMutation } from "@apollo/client";
import {
  ADD_COMPETITION,
  GET_COMPETITIONS,
  COMPETITIONS_WITH_PERMISSION,
} from "../../GraphQL/Competitions.js";
import useNotification from "../../hooks/useNotification.js";

const NewCompetitionDialog = (props) => {
  const [competition, setCompetition] = useState({ name: "", description: "", url: "" });
  const { notifySuccess } = useNotification();

  const isValid = competition.name.trim().length > 0;

  const [addCompetition, { loading, error }] = useMutation(ADD_COMPETITION, {
    variables: {
      name: competition.name,
      description: competition.description,
      url: competition.url,
    },
    refetchQueries: [GET_COMPETITIONS, COMPETITIONS_WITH_PERMISSION],
    onCompleted: () => { notifySuccess("Competition created."); props.setOpen(false); },
  });

  return (
    <div>
      <ResponsiveDialog
        open={props.open}
        onKeyDown={(e) => {
          if (e.key === "Enter" && isValid) {
            addCompetition();
          } else if (e.key === "Escape") {
            props.setOpen(false);
          }
        }}
        title="Competition"
        onClose={() => props.setOpen(false)}
      >
        <DialogContent>
          <TextField
            data-testid="name"
            autoFocus
            margin="dense"
            id="name"
            label="Name"
            type="text"
            fullWidth
            variant="standard"
            onChange={(e) => {
              setCompetition({ ...competition, name: e.target.value });
            }}
            inputProps={{ maxLength: 20 }}
            helperText={`${competition.name.length}/20`}
          />
          <TextField
            data-testid="description"
            margin="dense"
            id="description"
            label="Description"
            type="text"
            fullWidth
            variant="standard"
            onChange={(e) =>
              setCompetition({ ...competition, description: e.target.value })
            }
            inputProps={{ maxLength: 20 }}
            helperText={`${competition.description.length}/20`}
          />
          <TextField
            data-testid="url"
            margin="dense"
            id="url"
            label="URL"
            type="text"
            fullWidth
            variant="standard"
            onChange={(e) =>
              setCompetition({ ...competition, url: e.target.value })
            }
            inputProps={{ maxLength: 20 }}
            helperText={`${competition.url.length}/20`}
          />
        </DialogContent>
        {error && (
          <Alert severity="error" sx={{ mx: 2, mb: 1 }}>
            {error.message}
          </Alert>
        )}
        <DialogActions>
          <Button
            data-testid="saveNewCompetitionDialogButton"
            variant="contained"
            onClick={() => addCompetition()}
            disabled={loading || !isValid}
          >
            {loading ? (
              <CircularProgress size={20} sx={{ color: "inherit" }} />
            ) : (
              "Create"
            )}
          </Button>
          <Button
            data-testid="closeNewCompetitionDialogButton"
            onClick={() => props.setOpen(false)}
          >
            Cancel
          </Button>
        </DialogActions>
      </ResponsiveDialog>
    </div>
  );
};

export default NewCompetitionDialog;
